<template><div></div></template>
<script>
export default {
  name: "FronteggLogin",
  mounted() {
    window.location.href = `${process.env.VUE_APP_FRONTEGG_BASE_URL}/oauth/account/sign-up`;
  },
};
</script>
